import useListenForEvent from 'onyx-hooks/useListenForEvent'

const useListenForQueryDataUpdate = (cb) => {
  return useListenForEvent('QUERY_DATA_UPDATE', cb)
}

export default useListenForQueryDataUpdate
